import {make} from "vuex-pathify";
import API from "../services/API";

const state = {
    session: "invalid",
    activeUserRole: "ROOT",
    activeOrganization: null,
    activeTemplates: [],
    activeUserUUID: '',
    premises: [],
}

const mutations = {
    ...make.mutations(state),
    ADD_PREMISE(state, premise) {
        if (state.premises.findIndex(p => p.uuid === premise.uuid) === -1) {
            state.premises.push(premise);
        }
    }
}

const actions = {
    ...make.actions(state),

    async refreshPremises({ state }) {
        try {
            console.log('[refreshPremises] Fetching all premises from /premises endpoint...');
            const response = await API.getPremises(state.session);
            console.log('[refreshPremises] Received premises:', response.data.premises.length, 'premises');
            state.premises = response.data.premises;
            console.log('[refreshPremises] Store updated successfully');
            return response.data.premises;
        } catch (error) {
            console.error('[refreshPremises] Failed to refresh premises:', error);
            throw error;
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
